module.exports = __webpack_public_path__ + "img/info.b72fd661.svg";